/* eslint-disable jsdoc/check-param-names */
import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React from 'react';
import { ImageButton } from './Image.jsx';

export default class ImageButtonBrick extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */
    static getReactComponent($) {
        return (props) => {
            return (
                <ImageButton
                    image={useProperty($, 'Image')}
                    width={useProperty($, 'Width')}
                    height={useProperty($, 'Height')}
                    padding={useProperty($, 'Padding')}
                    tooltipText={useProperty($, 'Tooltip Text')}
                    tooltipPlacement={useProperty($, 'Tooltip Placement')}
                    cssProperty={useProperty($, 'CSS Property')}
                    onClick={() => {
                        $.trigger('On Click');
                    }}
                />
            );
        };
    }
}

registerBrick('0184c2e8bcf8d42c36a1', ImageButtonBrick);
